import React, { useState } from 'react';
import { Check, Share2 } from 'lucide-react';
import { shareProperty, copyShareLink } from '@/lib/share';

export const SHARE_STYLES = {
  solid: 'h-10 px-4 rounded-lg bg-[#C6A14A] text-[#050816] font-medium hover:bg-[#D4AF5A]',
  outline: 'h-9 px-3 rounded-lg border border-[#C6A14A]/40 text-[#C6A14A] hover:bg-[#C6A14A]/10',
  icon: 'h-9 w-9 justify-center rounded-full bg-black/60 backdrop-blur-sm text-white hover:bg-[#C6A14A] hover:text-[#050816]',
};

export const ShareButton = ({ slug, title, variant = 'outline', label = 'Share', className = '', testId, copyOnly = false }) => {
  const [done, setDone] = useState(false);
  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const result = copyOnly ? ((await copyShareLink(slug)) ? 'copied' : 'failed') : await shareProperty(slug, title);
    if (result === 'copied' || result === 'shared') {
      setDone(true);
      setTimeout(() => setDone(false), 2000);
    }
  };
  const Icon = done ? Check : Share2;
  return (
    <button type="button" onClick={onClick} aria-label={`Share ${title || 'property'}`} data-testid={testId}
      className={`inline-flex items-center gap-1.5 text-sm whitespace-nowrap transition-colors active:scale-95 ${SHARE_STYLES[variant]} ${className}`}>
      <Icon className="h-4 w-4" />
      {variant !== 'icon' && label}
    </button>
  );
};
